export const imageURL = 'https://botest.bonoapp.ge/api'
export const baseURL = imageURL + '/api/'


// WEBPACK FOOTER //
// ./src/settings/settings.js